<template>
    <div class="container-medium m-auto">
        <div v-loading="loading" class="mx-5">
            <terms-form
                :corporation="corporation"
                :type="type"
                :terms="terms"
                @load="load"
                @terms-accepted="callback"
            >
                <template #button>
                    {{ $filters.capitalize($l10n.__("j'accepte les conditions générales")) }}
                </template>
            </terms-form>
        </div>
    </div>
</template>
<script>
import TermsForm from 'vcomponents/sellsyaccountmanager/TermsForm.vue';

export default {

    components: {
        TermsForm,
    },
    props: {
        corporation: {
            type: String,
            required: true,
        },
        terms: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        redirect: {
            type: String,
            default: '/home',
        },
    },
    data() {
        return {
            terms_checked: false,
            loading: false,
        };
    },
    methods: {
        load(load) {
            this.loading = load;
        },
        callback() {
            this.load(true);
            window.location.href = this.redirect;
        },
    },
};
</script>
